const EnlivLogo = ({
  width = 1080,
  height = 1080,
  backgroundColor = '#387CA3',
  aspectRatio = 1,
} = {}) => {
  //   const viewBoxWidth = Math.max(width, height * aspectRatio);
  //   const viewBoxHeight = Math.max(height, width / aspectRatio);

  return (
    <div>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 1080 1080`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M347.325 218C288.113 218 240.111 266.001 240.111 325.214V736.786C240.111 795.999 288.113 844 347.325 844H733.294C792.507 844 840.508 795.999 840.508 736.786V721.087H330.581V621.041H558.128V440.961H330.581V340.915H840.508V325.214C840.508 266.001 792.507 218 733.294 218H347.325ZM654.082 440.961V621.041H840.508V440.961H654.082Z"
          fill={backgroundColor}
        />
      </svg>
    </div>
  );
};

export default EnlivLogo;
